<template>
	<div class="bottom">
		<div class="bottom-center">
			<ul>
				<!-- 联系方式 -->
				<li>
					<h2>联系我们</h2>
					<h1>北京信安天途科技有限公司</h1>
					<div class="contact">
						<ul>
							<li>咨询热线<i class="iconfont icon-dianhua"></i></li>
							<li>010-68848812</li>
						</ul>
						<ul>
							<li>企业邮箱<i class="iconfont icon-youxiang"></i></li>
							<li>services@skyroadsecurity.com</li>
						</ul>
					</div>
				</li>
				<!-- 服务项目 -->
				<li>
					<h2>服务项目</h2>
					<div class="items">
						<span>技术咨询</span>
						<span>技术转让</span>
						<span>软件开发</span>
						<span>软件销售</span>
						<span>技术服务</span>
						<span>专业设计服务</span>
						<span>软件外包服务</span>
						<span>安全咨询服务</span>
					</div>
				</li>
			</ul>
			<font>Copyright © 2021 信安天途 All Rights Reserved   版权所有 侵权必究  京公网安备 11010802034570号  京ICP备2021006610</font>
		</div>
	</div>
</template>

<script>
export default {
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped lang='scss'>
	.bottom{
		position: fixed;
		bottom: 0PX;
		left: 0PX;
		width:100% ;
		background-color: rgba(1, 101, 137, 0.47);
		display: flex;
		justify-content: center;
		.bottom-center{
			display: flex;
			flex-direction: column;
			box-sizing: border-box;
			padding: 10PX 0;
			box-sizing: border-box;
			font{
				color: #000;
				font-size: 12PX;
				
			}
			>ul{
				display: flex;
				flex-direction: row;
				color: #fff;
				margin-bottom: 10PX;
				>li{
					border-right: 1PX solid #fff;
					padding: 0PX 30PX;
					&:last-child{
						border-right:0PX;
						padding-right: 0PX;
						width: 400PX;
					}
					&:first-child{
						padding-left: 0PX;
					}
					h2{
						font-weight: bolder;
						font-size: 16PX;
						line-height: 30PX;
					}
					h1{
						font-weight: bolder;
						font-size: 18PX;
					}
					.items{
						display: flex;
						flex-flow: wrap;
						span{
							font-size: 13PX;
							color: #000;
							font-weight: bolder;
							border: 1PX solid #fff;
							padding:4PX;
							margin-right: 10PX;
							border-radius: 2PX;
							margin-top: 10PX;
							line-height: 1;
						}
						
					}
					.contact{
						font-size: 13PX;
						color: #000;
						font-weight: bolder;
						display: flex;
						flex-direction: row;
						>ul{
							flex: 1;
							display: flex;
							flex-direction: column;
							margin-right: 10PX;
							li{
								display: flex;
								align-items: center;
								
								i{
									color: #fff;
									margin-left: 5PX;
									font-weight: 400;
									font-size: 18PX;
								}
							}
							
						}
					}
				}
			}
		}
		
	}

</style>
